import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import Slider, { Settings } from 'react-slick';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Homeimages, sale1, sale2, sale3 } from '../../../../assets';

/* ---------------- WATER DROP CIRCLE ---------------- */
const WaterDropSalesCircle = () => (
  <Box
    sx={{
      position: 'relative',
      width: 180,
      height: 180,
      borderRadius: '50%',
      background: 'rgba(255,255,255,0.65)',
      backdropFilter: 'blur(12px)',
      WebkitBackdropFilter: 'blur(12px)',
      boxShadow: `
        0 30px 60px rgba(0,0,0,0.18),
        inset 0 8px 16px rgba(255,255,255,0.8),
        inset 0 -12px 22px rgba(0,0,0,0.1)
      `,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,

      /* TOP CURVED HIGHLIGHT */
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 14,
        left: 22,
        width: '65%',
        height: '45%',
        borderRadius: '50%',
        background:
          'radial-gradient(circle at top left, rgba(255,255,255,0.95), rgba(255,255,255,0.2) 60%, transparent 70%)',
        filter: 'blur(2px)',
      },

      /* BOTTOM REFRACTION */
      '&::after': {
        content: '""',
        position: 'absolute',
        bottom: 20,
        right: 26,
        width: '55%',
        height: '35%',
        borderRadius: '50%',
        background:
          'radial-gradient(circle at bottom right, rgba(255,255,255,0.45), transparent 70%)',
        filter: 'blur(6px)',
      },
    }}
  >
     <Box
    component="img"
    src={Homeimages.rwbluelogo2}   // 🔁 replace with your image path
    alt="Sales Coaching"
    sx={{
      width: '60%',
      height: '60%',
      objectFit: 'contain',
      zIndex: 2,
    }}
  />
  </Box>
);
const SlickSlider = Slider as unknown as React.FC<any>;




/* ---------------- GLASS DROPS ---------------- */
const GlassDrop = ({ size = 42 }: { size?: number }) => (
  <Box
    sx={{
      width: size,
      height: size,
      borderRadius: '50%',
      background: 'rgba(255,255,255,0.55)',
      backdropFilter: 'blur(8px)',
      WebkitBackdropFilter: 'blur(8px)',
      boxShadow: `
        inset 0 2px 4px rgba(255,255,255,0.9),
        inset 0 -4px 8px rgba(255,255,255,0.4),
        0 14px 28px rgba(0,0,0,0.2)
      `,
    }}
  />
);

const sliderSettings: Settings = {
  dots: true,
  arrows: false,
  infinite: true,
  speed: 600,
  autoplay: true,
  autoplaySpeed: 4200,
};

const cards = [
  {
    title: 'WHAT THIS COACHING HELPS YOU FIX',
    image: sale1,
    slides: [
      [
        'Strengthen how you communicate with buyers without sounding pushy',

      ],
      [
        'Build a healthier and more predictable sales pipeline',
      ],
      [

        'Improve follow-ups so momentum doesn’t drop after site visits',
      ],
      [

        'Handle pricing, trust, and comparison objections with clarity',
      ],

      ['Develop the mindset and confidence required to sell consistently'],
    ],
  },
  {
    title: 'WHY THIS WORKS',
    image: sale2,
    slides: [
      ['This is not theory-based training',
        'Built on real sales situations',
      ],
      [
        
        'Proven frameworks and practical psychology',
      ],
      ['Conversations feel natural, structured, and effective'],
    ],
  },
  {
    title: 'WHAT YOU GAIN',
    image: sale3,
    slides: [
      [
        'Clear sales structure and repeatable conversations',
        'Stronger negotiation control',
      ],
      ['Better buyer confidence and faster decisions'],
      ['A refined personal brand and professional presence'],
    ],
  },
];
/* ---------------- MAIN STRIP ---------------- */
const SalesCoachingStrip = () => {
  return (
    <Box
      sx={{
        background: '#EEEDE7',
        py: { xs: 6, md: 6 },
        position: 'relative',
        overflow: 'hidden',

        /* BLUE DOTS */
        '& .slick-dots li button:before': {
          color: '#1E88E5',
          fontSize: 10,
          opacity: 0.35,
        },
        '& .slick-dots li.slick-active button:before': {
          opacity: 1,
        },
      }}
    >
      {/* FLOATING DROPS – HIDDEN ON MOBILE */}
      <Box sx={{ display: { xs: 'none', md: 'block' } }}>
        <Box sx={{ position: 'absolute', left: 60, top: '55%' }}>
          <GlassDrop size={52} />
        </Box>
        <Box sx={{ position: 'absolute', left: 120, top: '70%' }}>
          <GlassDrop size={28} />
        </Box>
        <Box sx={{ position: 'absolute', right: 80, top: '45%' }}>
          <GlassDrop size={46} />
        </Box>
        <Box sx={{ position: 'absolute', right: 150, top: '68%' }}>
          <GlassDrop size={30} />
        </Box>
      </Box>

      <Container maxWidth="xl">
        <Box
          sx={{
            display: 'flex',
            gap: 6,
            alignItems: 'flex-start',
            flexDirection: { xs: 'column', md: 'row' },
            position: 'relative',
            px:{xs:4,lg:'auto'}
          }}
        >
          {/* CENTER WATER DROP – POSITIONED ABSOLUTELY */}
          <Box sx={{ display: { xs: 'none', md: 'block' }, position: 'absolute', top: 60, left: 0 }}>
            <WaterDropSalesCircle />
          </Box>

          {/* CARDS */}
          <Box display="flex" gap={5} sx={{ flexDirection: { xs: 'column', md: 'row' }, width: '100%', justifyContent: { xs: 'center', md: 'center' }, overflow: { xs: 'visible', md: 'auto' } }}>
            {cards.map((card, index) => (
              <Box
                key={index}
                width={{ xs: '100%', md: 300 }}
                display="flex"
                flexDirection="column"
                flexShrink={{ xs: 0, md: 1 }}
              >
                {/* IMAGE */}
                <Box
                  component="img"
                  src={card.image}
                  sx={{ height: 230, borderRadius: 3, width: '100%' }}
                />

                {/* ⭐ FIX: TITLE HEIGHT LOCK */}
                <Box  mt={3} display="flex" alignItems="flex-start"
                sx={{height:{xs:21,lg:48}}}
                >
                  <Typography
                  variant='h6'
                    fontWeight={700}
                    fontSize={12}
                    letterSpacing="0.06em"
                    textAlign="start"
                  >
                    {card.title}
                  </Typography>
                </Box>

                {/* ⭐ FIX: CONTENT + DOTS LOCK */}
                {/* ⭐ FIX: CONTENT + DOTS LOCK */}
                <Box height={{ xs: 'auto', md: 150 }} mt={2} display="flex" flexDirection="column">
                  <Box flexGrow={1}>
                    <SlickSlider {...sliderSettings}>
                      {card.slides.map((slide, i) => (
                        <Box
                          key={i}
                          sx={{
                            height: { xs: 'auto', md: 105 },
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'flex-start',
                            alignItems: 'flex-start',
                          }}
                        >
                          {slide.map((point, j) => (
                            <Box
                              key={j}
                              sx={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                gap: 1,
                                mb: 1,
                              }}
                            >
                              {/* DOT */}
                              <Box
                                component="span"
                                sx={{
                                  fontSize: 18,
                                  lineHeight: '22px',
                                  color: '#5B6472',
                                  flexShrink: 0,
                                  textAlign: 'start'
                                }}
                              >
                                •
                              </Box>

                              {/* TEXT */}
                              <Typography
                              variant='body2'
                                sx={{
                                  fontSize: 14.5,
                                  lineHeight: 1.6,
                                  color: '#222',
                                  textAlign: 'start',
                                }}
                              >
                                {point}
                              </Typography>
                            </Box>
                          ))}
                        </Box>
                      ))}
                    </SlickSlider>
                  </Box>
                </Box>

              </Box>
            ))}
          </Box>
        </Box>
      </Container>
    </Box>
  );
};


export default SalesCoachingStrip;
